export default "__VITE_ASSET__C9qasuUA__"